import { Component, Input } from '@angular/core';
import { FabBadge } from '../../fab.model';

@Component({
    selector: 'layout-fab-badge',
    templateUrl: './fab-badge.component.html',
    styleUrls: ['./fab-badge.component.scss']
})
export class FabBadgeComponent {
    @Input() badge: FabBadge;
}
